module.exports = __webpack_public_path__ + "731040925bfa1f44a8358e75d027dceb.svg";